import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const CloseFilledIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.364 10.9498L17.3138 6L18.728 7.41421L13.7782 12.364L18.728 17.3137L17.3138 18.7279L12.364 13.7782L7.41422 18.7279L6 17.3137L10.9498 12.364L6 7.41421L7.41422 6L12.364 10.9498Z"
        fill={fillColor || '#111112'}
      />
    </svg>
  );
};

export { CloseFilledIcon };
